import React from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import '../styles/basicLayout.css'
import StartIcon from "../assets/star-icon.png";
import { useHistory } from "react-router-dom";

function Menu() {
  let history = useHistory();
  const menus = [
    {
      id: 0,
      text: "Program Mode",
      path: "program"
    },
    {
      id: 1,
      text: "Select Program Mode",
      path: "select-program"
    },
    {
      id: 2,
      text: "Learn Mode",
      path: "learn-mode"
    },
    {
      id: 3,
      text: "Manual Mode",
      path: "manual-mode"
    },
    {
      id: 4,
      text: "Turn Product",
      path: "turn"
    },
    {
      id: 5,
      text: "Run Mode",
      path: "run-mode"
    },
  ];
  return (
    <>
      <header>
        <div className="left">
          <img width="80px" src={StartIcon} alt="" />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center">
          <h2>Menu</h2>
        </div>
        <div className="right">
        </div>
      </header>
      <article>
        <div className="left"></div>
        <div className="center"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            overflow: 'auto',
            height: '100vh'
          }}
        >
          {menus.map((item) => (
            <h3 className="main_list_elem" onClick={() => {
              history.push({
                pathname: `/${item.path}`,
                state: { item },
              });
            }}> {item.text} </h3>
          ))}
        </div>
        <div className="right">
        </div>
      </article>
    </>
  );
}

export default Menu;
